import { useEffect } from 'react'
import { useGeminiPanel } from '../contexts/GeminiPanelContext'
import { useGeminiContext } from '../contexts/GeminiContextContext'
import { GeminiSuggestions } from './GeminiSuggestions'
import { AISuggestion } from '../services/aiService'
import './GeminiPanel.css'

export function GeminiPanel() {
  const { isOpen, closePanel } = useGeminiPanel()
  const { consultationContext } = useGeminiContext()

  // Don't block body scroll for floating panel

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        closePanel()
      }
    }
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, closePanel])

  if (!isOpen) return null

  const handleSuggestionClick = (suggestion: AISuggestion) => {
    // This will be handled by the ConsultationWorkspace component
    // We can emit a custom event or use a callback context
    const event = new CustomEvent('gemini-suggestion-click', { detail: suggestion })
    window.dispatchEvent(event)
  }

  return (
    <div className={`gemini-panel ${isOpen ? 'open' : ''}`}>
        <div className="gemini-panel-header">
          <h2>AI Suggestions</h2>
          <button
            className="gemini-panel-close"
            onClick={closePanel}
            aria-label="Close AI panel"
            title="Close"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="gemini-panel-body">
          {consultationContext ? (
            <GeminiSuggestions
              context={consultationContext}
              onSuggestionClick={handleSuggestionClick}
            />
          ) : (
            <div className="gemini-panel-empty">
              <p>No consultation context available.</p>
              <p className="hint">Open a consultation workspace to get AI suggestions.</p>
            </div>
          )}
        </div>
      </div>
  )
}






























